import styled from "styled-components";

export const TippingHistoryDaysSelectorBox = styled.select`
    width: 250px;
    height: 35px;
    border-radius: 15px;
    background-color: ${props => props.theme.components.gamingHistory.colors.recordBackground};
    color: ${props => props.theme.components.gamingHistory.colors.textColor};
    font-size: ${props => props.theme.font.size.medium};
    padding-left: 10px;
  
    @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      width: 100%;
    }
`